import { c as e, i as t } from "./links-box.service-CGql-tfK.js";
import { getI18n as n } from "@editor/ui-utils";
import { QBtn as r, QDialog as i } from "quasar";
import { createBlock as a, createElementVNode as o, createVNode as s, defineAsyncComponent as c, defineComponent as l, mergeModels as u, openBlock as d, ref as f, unref as p, useModel as m, watch as h, withCtx as g } from "vue";
import { useI18n as _ } from "vue-i18n";
//#endregion
//#region src/lang/index.ts
var v = {
	en: {
		linksBoxApi: {
			createAlreadyExists: "The partner link box cannot be created because another link box with this name already exists.",
			updateAlreadyExists: "The partner link box cannot be updated because another link box with this name already exists.",
			created: "Partner link box created",
			updated: "Partner link box updated",
			notFound: "Partner link box not found",
			requiredFields: "The link cannot be saved because mandatory information is missing."
		},
		linksBoxList: {
			newButton: "New partner link box",
			name: "Search for partner linbox title or ID",
			deleteLinksBox: "Delete",
			dpAny: "All",
			brand: "Brand",
			loading: "Loading partner link box",
			headerLabel: "Label",
			headerCreatedAt: "Creation date",
			headerChangedAt: "Last modified date",
			counter: "Counter",
			dpEdit: "Edit",
			dpView: "View",
			messageDeleted: "Message deleted",
			errorOnDeleting: "Error deleting",
			createLinksBox: "Create partner link box",
			linkBoxTitle: "Title",
			linkBoxDescription: "Description (internal)",
			linkBoxID: "Partner link box ID",
			listType: "List type",
			links: "Links",
			publishedAt: "Publish date",
			changedAt: "Last modified date",
			selectedLinkBoxesCount: "{count} partner link boxes selected out of a maximum of {maximum}",
			boxType: "Type",
			types: {
				static: "Static",
				dynamic: "Dynamic",
				mostread: "Most read",
				newsfeed: "Newsfeed"
			},
			dynamicLinksCount: "Automatic"
		},
		linksBox: {
			linksBoxLabel: "Partner link box",
			newLinksBox: "Basics",
			messageDeleteLinksBox: "Are you sure you want to delete this partner link box?",
			messageDeleteLinksBoxTitle: "Delete partner link box",
			deleteLinksBox: "Delete",
			messageDeleted: "Partner link box deleted",
			errorOnDeleting: "Error deleting the partner link box",
			errorFailedLoadedLinksBoxWithId: "Error getting the partner link box",
			duplicateLinksBox: "Duplicate"
		},
		linksBoxEdit: {
			label: "Label",
			counter: "Counter",
			editLinksBox: "Basics",
			messageCreated: "New partner linkbox saved",
			messageSaved: "Changes saved",
			linkBoxDynamicOption: "Dynamic feed",
			linkBoxFixedOption: "Fixed links",
			linkBoxMoreButtonLabel: "Alternative text for \"More\" button (mobile)",
			linkBoxDescription: "Description (internal)",
			overviewPageLinkLabel: "Link to overview page",
			linkButton: "Link",
			newLinkTitle: "New link",
			editLinkTitle: "Edit link",
			saveLinkButton: "Save link",
			requiredFields: "Each configured link has to include either a title or a description.",
			linkDescriptionHint: "The description is for internal use only and is not rendered.",
			addFeedUrl: "Add feed URL",
			teaserImage: "Teaser image",
			teaserImageDescription: "Select or upload teaser image (optional)",
			teaserImageTooltip: "Rendering size will be 60 x 45 pixels",
			linkTitle: "Title",
			linkDescription: "Description (internal)",
			linkUrl: "Link URL",
			addSelectedLinkBoxesButton: "Add selected partner link boxes",
			dynamicLinkBoxInfo: "This partner link box is read only.",
			feedSource: "Feed source",
			newsFeedDisclaimer: "Links are contextually dynamic. Based on presence in channel tree.",
			brandChangeMessage: "All links will be removed in case the brand is changed. Are you sure you want to continue?",
			isAdvertisingBox: "Mark entire box as ad",
			isAdvertisingBoxTooltip: "Marks the entire link box as advertising. All links in this box will be labeled as \"Anzeige\".",
			isAdvertisingLink: "Mark link as ad",
			isAdvertisingLinkTooltip: "Marks this individual link as advertising. The link will be labeled with \"Anzeige\".",
			sourceChannel: "Source channel (optional)",
			sourceChannelNoResults: "No channels found",
			articlesType: "Article type filter",
			articlesTypeAll: "All types",
			includeSubchannels: "Include subchannels",
			includeSecondaryChannel: "Include secondary channel",
			includeNoIndex: "Include noIndex articles",
			shownLinksCount: "Number of links (4–10)",
			timespanDays: "Timespan",
			timespanDays7: "7 days",
			timespanDays30: "30 days"
		}
	},
	de: {
		linksBoxApi: {
			createAlreadyExists: "Die Partner-Linkbox kann nicht erstellt werden, weil bereits eine Linbox mit diesem Namen existiert.",
			updateAlreadyExists: "Die Partner-Linkbox kann nicht aktualisiert werden, weil bereits eine Linbox mit diesem Namen existiert.",
			created: "Partner-Linkbox erstellt",
			updated: "Partner-Linkbox aktualisiert",
			notFound: "Partner-Linkbox nicht gefunden",
			requiredFields: "Der Link kann nicht gespeichert werden, weil Pflichtinformationen fehlen."
		},
		linksBoxList: {
			newButton: "Neue Partner-Linkbox",
			name: "Suchen nach Partner-Linkbox-Titel oder -ID",
			deleteLinksBox: "Löschen",
			dpAny: "Alle",
			brand: "Marke",
			loading: "Partner-Linkbox wird geladen",
			headerLabel: "Bezeichnung",
			headerCreatedAt: "Erstellungsdatum",
			headerChangedAt: "Änderungsdatum (last modified)",
			counter: "Zähler",
			dpEdit: "Bearbeiten",
			dpView: "Anzeigen",
			messageDeleted: "Nachricht gelöscht",
			errorOnDeleting: "Fehler beim Löschen",
			createLinksBox: "Partner-Linkbox erstellen",
			linkBoxTitle: "Title",
			linkBoxDescription: "Description (internal)",
			linkBoxID: "Partner-Linkbox-ID",
			listType: "Listen-Typ",
			links: "Links",
			publishedAt: "Veröffentlichungsdatum (publish date)",
			changedAt: "Änderungsdatum (last modified)",
			selectedLinkBoxesCount: "{count} von maximal {maximum} ausgewählten Partner-Linkboxen",
			boxType: "Typ",
			types: {
				static: "Statisch",
				dynamic: "Dynamisch",
				mostread: "Meistgelesen",
				newsfeed: "Newsfeed"
			},
			dynamicLinksCount: "Automatisch"
		},
		linksBox: {
			linksBoxLabel: "Partner-Linkbox",
			newLinksBox: "Basics",
			messageDeleteLinksBox: "Willst du diese Partner-Linkbox wirklich löschen?",
			messageDeleteLinksBoxTitle: "Partner-Linkbox löschen",
			deleteLinksBox: "Löschen",
			messageDeleted: "Partner-Linkbox gelöscht",
			errorOnDeleting: "Fehler beim Löschen der Partner-Linkbox",
			errorFailedLoadedLinksBoxWithId: "Fehler beim Abrufen der Partner-Linkbox",
			duplicateLinksBox: "Duplizieren"
		},
		linksBoxEdit: {
			label: "Bezeichnung",
			counter: "Zähler",
			editLinksBox: "Basics",
			messageCreated: "Neue Partner-Linkbox gespeichert",
			messageSaved: "Änderungen gespeichert",
			linkBoxDynamicOption: "Dynamischer Feed",
			linkBoxFixedOption: "Festgelegte Links",
			linkBoxMoreButtonLabel: "Alternativer Text für \"Mehr\"-Button (mobil)",
			linkBoxDescription: "Beschreibung (intern)",
			overviewPageLinkLabel: "Link zur Überssichtsseite",
			linkButton: "Link",
			newLinkTitle: "Neuer Link",
			editLinkTitle: "Link bearbeiten",
			saveLinkButton: "Link speichern",
			requiredFields: "Jeder angelegte Link muss entweder einen Titel oder eine Beschreibung enthalten.",
			linkDescriptionHint: "Die Beschreibung dient nur der internen Nutzung und wird nicht veröffentlicht.",
			addFeedUrl: "Feed-URL hinzufügen",
			teaserImageDescription: "Teaserbild auswählen oder hochladen (optional)",
			teaserImage: "Teaserbild",
			teaserImageTooltip: "Rendering-Größe: 60 x 45 Pixel",
			linkTitle: "Titel",
			linkDescription: "Beschreibung (intern)",
			linkUrl: "Link-URL",
			addSelectedLinkBoxesButton: "Ausgewählte Partner-Linkboxen hinzufügen",
			dynamicLinkBoxInfo: "Diese Partner-Linkbox ist nur zum Lesen.",
			feedSource: "Feed-Quelle",
			newsFeedDisclaimer: "Links sind kontextabhängig dynamisch – basierend auf ihrer Position im Channel-Baum.",
			brandChangeMessage: "Alle Links werden entfernt, wenn die Marke geändert wird. Willst du wirklich fortfahren?",
			isAdvertisingBox: "Gesamte Box als Anzeige markieren",
			isAdvertisingBoxTooltip: "Markiert die gesamte Linkbox als Werbung. Alle Links in dieser Box werden als \"Anzeige\" gekennzeichnet.",
			isAdvertisingLink: "Link als Anzeige markieren",
			isAdvertisingLinkTooltip: "Markiert diesen einzelnen Link als Werbung. Der Link wird mit \"Anzeige\" gekennzeichnet.",
			sourceChannel: "Quell-Channel (optional)",
			sourceChannelNoResults: "Keine Channels gefunden",
			articlesType: "Artikeltyp-Filter",
			articlesTypeAll: "Alle Typen",
			includeSubchannels: "Subchannels einbeziehen",
			includeSecondaryChannel: "Sekundären Channel einbeziehen",
			includeNoIndex: "NoIndex-Artikel einbeziehen",
			shownLinksCount: "Anzahl der Links (4–10)",
			timespanDays: "Zeitraum",
			timespanDays7: "7 Tage",
			timespanDays30: "30 Tage"
		}
	}
}, y = [{
	path: "/links-box",
	children: [
		{
			path: "",
			name: "links_box_list",
			component: () => import("./links-box-list.view-ej8WS0-R.js"),
			meta: { requiredRight: "links-boxes:navigate" }
		},
		{
			path: "new",
			name: "links_box_new",
			component: () => import("./links-box-edit.view-DG6_eZRa.js"),
			props: () => ({
				title: n().t("linksBox.newLinksBox"),
				backRoute: "/links-box"
			}),
			meta: { requiredRight: ["links-boxes:navigate"] }
		},
		{
			path: ":id",
			name: "links_box_detail",
			component: () => import("./links-box-edit.view-DG6_eZRa.js"),
			props: (e) => ({
				title: n().t("linksBoxEdit.editLinksBox"),
				id: e.params.id,
				backRoute: "/links-box"
			}),
			meta: { requiredRight: ["links-boxes:navigate"] }
		}
	]
}], b = { class: "dialog-footer q-pa-md" }, x = { class: "col" }, S = /* @__PURE__ */ e(/* @__PURE__ */ l({
	__name: "link-box-list-selector",
	props: /* @__PURE__ */ u({
		brand: { default: void 0 },
		disableBrand: {
			type: Boolean,
			default: !1
		},
		maxLinkBoxes: { default: void 0 }
	}, {
		modelValue: { default: () => [] },
		modelModifiers: {},
		dialogVisible: {
			type: Boolean,
			default: !1
		},
		dialogVisibleModifiers: {}
	}),
	emits: /* @__PURE__ */ u(["update:brand"], ["update:modelValue", "update:dialogVisible"]),
	setup(e) {
		let t = c(() => import("./links-box-list.view-ej8WS0-R.js")), n = m(e, "modelValue"), l = m(e, "dialogVisible"), { t: u } = _(), v = f([]), y = () => {
			n.value = v.value, l.value = !1, v.value = [];
		}, S = () => {
			v.value = [], l.value = !1;
		}, C = (e) => {
			v.value.find((t) => t._id === e._id) ? v.value = v.value.filter((t) => t._id !== e._id) : v.value.push(e);
		};
		return h(() => n.value, (e) => {
			v.value = e;
		}), (n, c) => (d(), a(p(i), {
			"model-value": l.value,
			"data-qa-content-modal": "",
			"full-width": "",
			"full-height": "",
			onHide: c[3] ||= (e) => l.value = !1
		}, {
			default: g(() => [s(p(t), {
				modelValue: v.value,
				"onUpdate:modelValue": c[0] ||= (e) => v.value = e,
				brand: e.brand,
				"disable-brand": e.disableBrand,
				dialog: "",
				"show-new-button": !1,
				selection: "multiple",
				"max-selected-rows": e.maxLinkBoxes,
				onClose: c[1] ||= (e) => l.value = !1,
				"onBack:modal": c[2] ||= (e) => l.value = !1,
				"onClick:linksBox:select": C
			}, {
				footer: g(() => [o("div", b, [o("div", x, [s(p(r), {
					color: "primary",
					icon: "send",
					class: "q-mr-sm",
					label: p(u)("linksBoxEdit.addSelectedLinkBoxesButton"),
					"data-qa-articles-add-selector-button": "",
					onClick: y
				}, null, 8, ["label"]), s(p(r), {
					"text-color": "secondary",
					icon: "close",
					color: "primary",
					class: "q-mr-sm bg-white",
					label: p(u)("articles.cancelButton"),
					"data-qa-articles-cancel-selector-button": "",
					onClick: S
				}, null, 8, ["label"])])])]),
				_: 1
			}, 8, [
				"modelValue",
				"brand",
				"disable-brand",
				"max-selected-rows"
			])]),
			_: 1
		}, 8, ["model-value"]));
	}
}), [["__scopeId", "data-v-31571620"]]), C = {
	messages: v,
	routes: y
};
//#endregion
export { S as LinkBoxListSelector, t as getLinkBoxesFromIds, C as linksBoxModule };

//# sourceMappingURL=index.es.js.map